export function getPaginationRequestParams(pagination) {
    const urlParams = new URLSearchParams();
    const { sort, ...filters } = pagination;

    Object.keys(filters ?? {}).forEach((key) => {
        urlParams.append(key, encodeURIComponent(pagination[key]).replace(/'/g, "%27"));
    });

    if (!!sort) {
        sort.split("-").forEach((sortElement) => {
            urlParams.append("sort[]", sortElement)
        });
    }

    return urlParams;
}